import { Icon, type SxProps, type Theme, Tooltip } from "@mui/material";
import cx from "classnames";
import { useMissingDataType } from "src/business-hooks/useMissingDataType";
import TruncationAwareTooltip from "src/components/general/TruncationAwareTooltip/TruncationAwareTooltip";
import type { AssetItemProps } from "./AssetNameWithIcon.props";
import { getMetadataByAssetType } from "./AssetNameWithIcon.utils";

export const AssetNameWithIcon = ({
  name,
  type,
  withTooltip = false,
  className,
  sx = {},
}: AssetItemProps) => {
  const assetData = getMetadataByAssetType(type);
  const AssetDataIcon = assetData?.Icon || Icon;
  const label = name || assetData?.tooltipTitle;
  const isTextLabel = typeof label === "string";

  sx = {
    color: ({ palette }: Theme) => palette.primary.main,
    fontSize: "16px",
    ...sx,
  } as SxProps;

  // TODO: question - why is this needed? doesn't seem to help much
  // (also should be a utility funciton and not a custom hook)
  useMissingDataType(
    "missingAssetTypeIcon",
    type,
    `Asset type ${type} not found`,
    !!type
  );

  return (
    <div className={cx("flex items-center gap-1.5", className)}>
      <Tooltip arrow title={withTooltip && assetData?.tooltipTitle}>
        <AssetDataIcon sx={sx} />
      </Tooltip>
      <TruncationAwareTooltip
        arrow
        placement="top"
        disableInteractive
        {...(isTextLabel ? {} : { title: "" })}
      >
        {label}
      </TruncationAwareTooltip>
    </div>
  );
};
